import { useEffect, useRef } from "react";
import { Flex, Input, message, Form } from "antd"
import { QuestionCircleOutlined } from "@ant-design/icons"
import TextArea from "antd/es/input/TextArea"
import { useParams } from "react-router-dom"
import { getActiveSetValue, getConditionalRevertValue, shouldRevertConditionalValue } from "../../../utils/formsHelper";
import { getPreviousDataByValue, getPublicPreviousDataByValue } from "../../../services/requestServices";

const TextAreaInput = (props) => {
    const { spaceId, requestId } = useParams()
    const { label, placeholder, tooltip, helpText, mandatory, readOnly, maxHeight, id, form, previewMode, previewmode, setValueData, enablePreviousDataFetch, requestDetail, isPublicForm = false } = props
    const isPreview = previewMode || previewmode;
    const isEditing = !!(requestDetail && Object.keys(requestDetail).length > 0);
    const rules = mandatory ? [{ required: true, whitespace: true }] : undefined;
    const disabled = previewMode && readOnly ? true : false
    const help = tooltip ? { title: helpText, icon: <QuestionCircleOutlined /> }
        : undefined;

    let activeSetValue = getActiveSetValue(setValueData, true)

    // What the condition last wrote here, so it can be taken back once the
    // condition stops passing without touching text the user typed since.
    const appliedFormValueRef = useRef(undefined)

    useEffect(() => {
        if (activeSetValue?.value) {
            form?.setFieldValue(id, activeSetValue.value)
            appliedFormValueRef.current = activeSetValue.value
        } else if (shouldRevertConditionalValue(activeSetValue, { disabled, currentValue: form?.getFieldValue(id), appliedValue: appliedFormValueRef.current })) {
            form?.setFieldValue(id, getConditionalRevertValue(id, props.defaultFormValues))
            appliedFormValueRef.current = undefined
        } else {
            appliedFormValueRef.current = undefined
        }
    }, [activeSetValue, disabled, form, id])

    const handleBlur = async (e) => {
        const value = e.target.value;
        if (!enablePreviousDataFetch || !isPreview || isEditing || !value) return;
        const response = isPublicForm
            ? await getPublicPreviousDataByValue(id, value, props.requestId, props.spaceId, props.shareToken)
            : await getPreviousDataByValue(id, value, spaceId, requestId);
        const fetchedValues = response?.data?.value;
        if (response.status === 200 && fetchedValues && typeof fetchedValues === "object") {
            const fieldsToSet = { ...fetchedValues };
            delete fieldsToSet[id];
            if (Object.keys(fieldsToSet).length > 0) {
                form?.setFieldsValue(fieldsToSet);
            }
        }
    };

    return (
        <div className="form-element">
            <Flex vertical>
                <Form.Item name={id} label={label} tooltip={help} rules={rules} >
                    <TextArea placeholder={placeholder} rows={maxHeight || 2} disabled={disabled} size="large" onBlur={handleBlur} />
                </Form.Item>
            </Flex>
        </div>
    )
}

export default TextAreaInput